import type { LayerStackSprite } from '../layerstack/LayerStackSprite';

/**
 * The ×2.5 renderer boundary, and the only place it is applied.
 *
 * The simulation stays 384×216 in every respect — positions, radii, scroll. The
 * RT rung art was authored at exactly 2.5×, so 384×216 × 2.5 is 960×540 and one
 * constant converts the whole scene at draw time. Nothing upstream of the
 * renderer knows the display is bigger, and nothing outside src/game/render/r2
 * imports this.
 */
export const WORLD_TO_R2 = 2.5;

/** Simulation coordinates are centre points; a layer stack draws from its top-left. */
export function placeSprite(sprite: LayerStackSprite, worldX: number, worldY: number): void {
  sprite.setPixelPosition(worldX * WORLD_TO_R2 - sprite.targetWidth / 2, worldY * WORLD_TO_R2 - sprite.targetHeight / 2);
}
